import { ErrorHandler, Injectable } from "@angular/core";
import { CotecnaUserService } from "@cotecna/session";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";
import { AppEvent } from "./app-event";

@Injectable({
  providedIn: "root",
})
export class ErrorLoggerService extends ErrorHandler {
  private loggedErrorMessageCounter = 0;

  constructor(
    private httpService: HttpService,
    private connectedUserService: CotecnaUserService,
  ) {
    super();
  }

  handleError(error: any): void {
    super.handleError(error);
    if (this.loggedErrorMessageCounter++ < 20) {
      var message = this.createAppEvent(error);
      this.logError(message);
    }
  }

  private logError(appEvent: AppEvent) {
    this.httpService
      .post(`${environment.webApiUrl}/api/app-events`, appEvent, {
        withCredentials: true,
      })
      .toPromise()
      .then((response) => {})
      .catch((error) => {});
  }

  private createAppEvent(error: any): AppEvent {
    let appEvent: AppEvent = {
      logLevel: "Error",
      user: this.connectedUserService.getUser().email,
      name: "error",
      params: error.toString(),
    };
    return appEvent;
  }
}
